import type { Schema } from '@/api/client'
import { WEEKDAYS, pad } from './cadence'

export type Schedule = Schema<'ScheduleOut'>

/** One line for a read-only row: `Weekly, Monday 06:00 IST · 2 automatic triggers`. */
export function summariseSchedule(schedule: Schedule): string {
  const at = `${pad(schedule.hour)}:${pad(schedule.minute)}`
  const zone = schedule.timezone === 'Asia/Kolkata' ? 'IST' : schedule.timezone.replace('_', ' ')
  let when: string
  if (!schedule.enabled) when = 'Not scheduled'
  else if (schedule.frequency === 'daily') when = `Daily, ${at} ${zone}`
  else if (schedule.frequency === 'weekdays') when = `Weekdays, ${at} ${zone}`
  else when = `Weekly, ${WEEKDAYS[(schedule.weekday ?? 1) - 1] ?? 'Monday'} ${at} ${zone}`
  const on = schedule.conditions.filter((condition) => condition.enabled).length
  return `${when} · ${String(on)} automatic ${on === 1 ? 'trigger' : 'triggers'}`
}
